import type { AccountInfo, IPublicClientApplication } from '@azure/msal-browser'
import { powerBiTokenRequest } from './../../authConfig'
import { TRANSLATION_KEYS } from 'locales/translation-keys'

export const loadReport = async ({
    accounts,
    instance,
    setError,
    t,
}: {
    accounts: AccountInfo[]
    instance: IPublicClientApplication
    setError: (error: string) => void
    t: (key: string) => string
}) => {
    try {
        // TODO: this will get used in MYPM-3321
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const tokenResponse = await handlePowerBILogin(accounts, instance)

        // TODO: Actually fetch the report in MYPM-3321
    } catch (err: unknown) {
        const errorMessage = (err as Error).message ?? 'Unknown error'
        if (errorMessage.includes('popup_window_error')) {
            setError(t(TRANSLATION_KEYS.powerBI.popupError))
        } else if (!errorMessage.includes('interaction_in_progress')) {
            setError(errorMessage)
        }
    }
}

const handlePowerBILogin = async (
    accounts: AccountInfo[],
    instance: IPublicClientApplication,
) => {
    let account = accounts[0]
    if (!account) {
        const loginResponse = await instance.loginPopup(powerBiTokenRequest)
        account = loginResponse.account
    }
    try {
        return await instance.acquireTokenSilent({
            ...powerBiTokenRequest,
            account,
        })
    } catch {
        return await instance.acquireTokenPopup({
            ...powerBiTokenRequest,
            account,
        })
    }
}
